// Webpack Imports
import 'bootstrap';
import 'slick-carousel';
import 'slick-lightbox';
import '../node_modules/owl.carousel2/dist/owl.carousel.js';
import '../node_modules/bootstrap/js/dist/collapse.js';

$(document).ready(function(){

    if($(window).width() > 991){
        $(document).on('click', '.nav-link.dropdown-toggle', function(e){
            e.preventDefault();
            location.href = $(e.currentTarget).attr('href');
        });
    }

    initHomeSlider();
    initFeaturedSlider();
    stickyheader();
    initBackToTop();
});

function initBackToTop(){
    const top_btn = document.getElementById('back-to-top');
    top_btn.addEventListener('click', () => window.scrollTo({
        top: 0,
        behavior: 'smooth',
    }));
}

function stickyheader(){
    let scrollpos = window.scrollY;
    const header = document.querySelector("header");
    const header_height = header.offsetHeight;

    const add_class_on_scroll = () => header.classList.add("header--sticky")
    const remove_class_on_scroll = () => header.classList.remove("header--sticky")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if (scrollpos >= header_height) { add_class_on_scroll() }
        else { remove_class_on_scroll() }

        console.log(scrollpos)
    })
}

function initFeaturedSlider(){
    var home = jQuery('.featured .owl-carousel').owlCarousel({
        items : 3,
        autoplay : true,
        autoplayTimeout : 5000,
        autoplayHoverPause : true,
        smartSpeed : 500,
        fluidSpeed : 500,
        autoplaySpeed : 500,
        navSpeed : 500,
        dotsSpeed : 500,
        loop : true,
        nav : true,
        dots: false,
        responsiveRefreshRate : 200,
        slideBy : 1,
        mergeFit : true,
        autoHeight : false,
        mouseDrag : false,
        touchDrag : true,
        margin: 30,
        responsive : {
            // breakpoint from 0 up
            0 : {
                items : 1,
            },
            // breakpoint from 480 up
            480 : {
                items : 1,
            },
            // breakpoint from 768 up
            768 : {
                items : 2,
            },
            992 : {
                items : 3,
            }
        }
    });
    home.css('visibility', 'visible');
}

function initHomeSlider(){
    var home = jQuery('.homeslider .owl-carousel').owlCarousel({
        items : 1,
        autoplay : true,
        margin: 0,
        autoplayTimeout : 5000,
        autoplayHoverPause : true,
        smartSpeed : 500,
        fluidSpeed : 500,
        autoplaySpeed : 500,
        navSpeed : 500,
        dotsSpeed : 500,
        loop : true,
        nav : true,
        dots: true,
        responsiveRefreshRate : 200,
        slideBy : 1,
        mergeFit : true,
        autoHeight : false,
        mouseDrag : false,
        touchDrag : true,
    });
    home.css('visibility', 'visible');
}

$(document).ready(function(){
    new WOW().init();
    $('.parallax-window').parallax();
});
